export default __webpack_public_path__ + "c688a4b6531cfa5e922e65d8f3702fef.png";